import { ChooseFromTemplateModule } from '@/modules/fantasy/fixture/choose-from-template';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/fantasy/fixture/choose-from-template'
)({
  validateSearch: searchSchema,
  component: ChooseFromTemplatePage,
});

function ChooseFromTemplatePage() {
  return <ChooseFromTemplateModule />;
}
